module.exports = __webpack_public_path__ + "media/images/riders/small/MARINE_CABIROU-972afc464ae54d6ec99c4d3d4a6b55c0.png";